import { FormControlLabel, Modal, Radio, RadioGroup } from '@material-ui/core'
import Card from '../../../components/common/Card'
import Text from '../../../components/common/Text'
import React, { useCallback, useState } from 'react'
import { Field, Form } from 'react-final-form'
import styled from '@emotion/styled'
import { InputField } from '../../../components/fields'
import { Button } from 'react-bootstrap'
import Input from '../../../components/common/Input'
import { EnumKycRejectedType } from '../../../services/kyc/kyc-typed'
import { colors } from 'react-select/src/theme'

const InputStyled = styled(Input)`
  &.MuiFormControl-root {
    width: 100%;
    margin-top: 0;
  }
`

const ContentLayout = styled(Card)`
  min-height: 200px;
  padding: 0px 24px;
  grid-row-gap: 12px;
  min-width: 450px;
`

const ModalStyled = styled(Modal)({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
})

export type RejectAccountFormValues = {
  type: EnumKycRejectedType
  remark?: string
}

type IModalFreezeAccount = {
  isOpen: boolean
  onSubmit: (values: RejectAccountFormValues) => void
  onClose: () => void
}

export const ModalFreezeAccount = (props: IModalFreezeAccount) => {
  const { isOpen, onClose, onSubmit } = props

  const validateRequired = useCallback((value: string) => (value ? undefined : 'required'), [])

  return (
    <ModalStyled open={isOpen} onClose={onClose}>
      <div>
        <Form<RejectAccountFormValues>
          onSubmit={onSubmit}
          //initialValues={initialValues}
        >
          {({ handleSubmit, dirty, submitting, valid, form, values }) => {
            return (
              <form onSubmit={handleSubmit}>
                <ContentLayout>
                  <Text variant="h5" bold style={{ textAlign: 'center', marginBottom: 16 }}>
                    กรุณาเลือกเหตุผล
                  </Text>
                  <Field name="type">
                    {({ input }) => {
                      return (
                        <RadioGroup {...input}>
                          <FormControlLabel
                            value={EnumKycRejectedType.OVER_SOLD}
                            control={<Radio />}
                            label="ขายเกิน"
                          />
                          <FormControlLabel
                            value={EnumKycRejectedType.SAFE_GOLD_CONDITION}
                            control={<Radio />}
                            label="Safe Gold Condition"
                          />
                        </RadioGroup>
                      )
                    }}
                  </Field>
                  {values.type === EnumKycRejectedType.SAFE_GOLD_CONDITION && (
                    <div style={{ marginTop: 16 }}>
                      <Text>หมายเหตุเพิ่มเติม</Text>
                      <Field name="remark" validate={validateRequired}>
                        {({ input, meta }) => {
                          return (
                            <>
                              <InputStyled
                                {...input}
                                placeholder="กรุณาใส่รายละเอียด"
                                multiline
                                rows={3}
                                onChange={value => input.onChange(value)}
                              />
                              {meta.error && meta.touched && (
                                <Text color={'#FF0000'}>{meta.error}</Text>
                              )}
                            </>
                          )
                        }}
                      </Field>
                    </div>
                  )}
                  <div
                    style={{
                      display: 'flex',
                      flexDirection: 'row',
                      justifyContent: 'center',
                      padding: '24px',
                      gridColumnGap: '10px',
                    }}
                  >
                    <Button
                      variant="primary"
                      type="submit"
                      disabled={!dirty || submitting || !valid}
                    >
                      Confirm
                    </Button>
                    <Button variant="outline-secondary" onClick={onClose}>
                      Cancel
                    </Button>
                  </div>
                </ContentLayout>
              </form>
            )
          }}
        </Form>
      </div>
    </ModalStyled>
  )
}
